/* eslint-disable no-extra-parens */
/* eslint-disable operator-linebreak */
import { UnitsProvider } from './react/common/providers/unitsProvider';

WB.AppController = function(
    $scope,
    $route,
    $timeout,
    $location,
    $document,
    GlobalClassUtility,
    _User,
    Metadata,
    _Config,
    PathHelper,
    ResponsiveMenu,
    Share,
    RoutingHistory,
    MetadataDataManager
) {
    var _this = this;

    // Save a reference to the App in the root scope

    $scope.$root.App = this;
    $scope.$root.$AppScope = $scope;
    $scope.$root.globalAdParams = {};

    $scope.$root.SelectedLocaleLanguage = WB.locale;
    //
    // Save services on App for DOM retrievel
    // NOTE: Do not use these in components and other services. Inject them like you would typically.
    // This is only for preventing superfluous, dubious service requests in places that are not needed
    // for DOM manipulation, etc. To remedy this in the future, we could create a DOM service that provides
    // only the DOM helpers (url, etc), and pulls in these services as needed.
    //

    this.focus = focus;
    this.$route = $route;
    this.Metadata = Metadata;
    this.config = _Config;
    this.PathHelper = PathHelper;
    this.ResponsiveMenu = ResponsiveMenu;
    this.Share = Share;
    this.User = _User;
    this.GlobalClassUtility = GlobalClassUtility;

    // This is referenced for the location switcher.

    this.generateBackgrounImageFromFileName = function(bgFileName) {
        if (!bgFileName) {
            return '';
        }
        let screenType = 'desktop';
        if ($scope.$root.isBreakpointMedium) {
            screenType = 'tablet';
        } else if ($scope.$root.isBreakpointSmall) {
            screenType = 'mobile';
        }
        const pageBackgroundParts = bgFileName.split('.');
        
        const uiBackgroundImage = pageBackgroundParts[0];
        const newbg = `${uiBackgroundImage}-${screenType}.jpeg`;
        return newbg;
    };

    $scope.$root.App.wrapAdBg = '';

    //Units - i for Farenheit, m for Celsius
    var url = $location.search();
    $scope.$root.App.PlatformCode = url.s == undefined ? 'wd' : url.s;
    if (navigator.userAgent.indexOf('weatherbug') != -1) {
        $scope.$root.App.PlatformCode = 'mi';
    }
    var mobileZipCode = url.zip == undefined ? '' : url.zip;
    if (
        navigator.userAgent.indexOf('Android') != -1 &&
		mobileZipCode != '' &&
		$scope.$root.App.PlatformCode != 'ma1'
    ) {
        $scope.$root.App.PlatformCode = 'ma';
    }

    $scope.$root.App.TempUnits = url.u == undefined ? '' : url.u == 'm' ? 'C' : 'F';
    if ($scope.$root.App.TempUnits != '') {
        var tempval = $scope.$root.App.TempUnits == 'F' ? 1 : 2;
        const unitsProvider = new UnitsProvider();
        unitsProvider.setUnits(tempval, tempval);
        _User.Units = tempval;
        _User.ActiveLocation.Units = tempval;
        _User.ActiveLocation.Locality.Units = tempval;
    }

    $scope.lastUrl = document.referrer;
    $scope.currentUrl = $location.absUrl();
    $scope.routeBootstrapped = false;

    Object.defineProperty(document, 'referrer', {
        get: function() {
            return $scope.lastUrl;
        }
    });

    $scope.$watch(
        function() {
            return _User.ActiveLocation;
        },
        function(newLocation) {
            if (!newLocation) {
                return;
            }

            //Set dynamic background on location switch
            $scope.$root.App.Lat = newLocation.Locality.Latitude;
            $scope.$root.App.Lng = newLocation.Locality.Longitude;
        }
    );

    $scope.$root.$on('$routeUpdate', function(e, targetRoute) {
        var previousRoute = RoutingHistory.get();

        MetadataDataManager.GetMetadataForUrl().then(function(metadata) {
            Metadata.set(metadata);
        });
        if (targetRoute.params.station !== previousRoute.params.station) {
            $route.reload();
        }
    });

    $scope.$root.$on('$routeChangeFinished', function(
        e,
        currentRoute,
        lastRoute
    ) {
        if (lastRoute == undefined) {
            MetadataDataManager.init();
            MetadataDataManager.GetMetadataForUrl().then(function(metadata) {
                Metadata.set(metadata);
                currentRoute.locals.metadata = metadata;

                if ($scope.app.$route.current.locals.controller == 'life') {
                    
                    $scope.$root.App.BackgroundFilename = metadata.CMSPageConfig.BackgroundImage;
                    const backgroundImage = $scope.$root.App.generateBackgrounImageFromFileName(metadata.CMSPageConfig.BackgroundImage);
                    $scope.$root.App.BackgroundUrl = backgroundImage;
                }
            });
        } else {
            if ($scope.app.$route.current.locals.controller == 'life') {
                $scope.$root.App.BackgroundFilename = $scope.app.Metadata.Data.CMSPageConfig.BackgroundImage;
                const backgroundImage = $scope.$root.App.generateBackgrounImageFromFileName($scope.app.Metadata.Data.CMSPageConfig.BackgroundImage);
                $scope.$root.App.BackgroundUrl = backgroundImage;
            }
        }

        // We do not need a background image in new hurricane page
        if ($scope.app.$route.current.locals.controller == 'hurricane' 
            || $scope.app.$route.current.locals.controller == 'forecasts'
            || $scope.app.$route.current.locals.controller == 'alerts'
            || $scope.app.$route.current.locals.controller == 'news'
            || $scope.app.$route.current.locals.controller == 'weatherlandingcamera'
            || $scope.app.$route.current.locals.controller == 'maps') {
            $scope.$root.App.BackgroundUrl = ''; 
        }

        if ($scope.routeBootstrapped) {
            var currentUrl = $location.absUrl();
            if (currentUrl !== $scope.lastUrl) {
                $scope.referrer = $scope.lastUrl;
                $scope.lastUrl = $scope.currentUrl;
                $scope.currentUrl = currentUrl;
            }
        } else {
            $scope.routeBootstrapped = true;
        }

        // Don't need the rest of this to run on initial page load
        if (!lastRoute) {
            return;
        }

        ResponsiveMenu.closeResponsiveMenu();

        // Reset the global classes
        GlobalClassUtility.initializeGlobalClasses();

        GlobalClassUtility.classes.forEach(function(c) {
            if (c.startsWith('is-route')) {
                GlobalClassUtility.removeClass(c);
            }
        });

        var globalPopupRouteClass = currentRoute.locals.popup
            ? 'is-route-forecasts'
            : 'is-route-' + currentRoute.locals.name;
        GlobalClassUtility.addClass(globalPopupRouteClass);
        GlobalClassUtility.toggleClass(
            'is-popup-open',
            !!currentRoute.locals.popup
        );

        if (_this._scrollToTopAfterNavigating) {
            _this.scrollToTop();
        }
    });

    // Return an object for the classes on the body element.
    // This is reactive based on scope changes (responsive menu, location switcher opening, etc).

    this.bodyClasses = function() {
        var obj = {};
        GlobalClassUtility.classes.forEach(function(c) {
            obj[c] = true;
        });
        return obj;
    };

    // Scroll to top functionality

    this.scrollToTopAfterNavigating = function() {
        this._scrollToTopAfterNavigating = true;
    };

    this.scrollToTop = function() {
        $timeout(function() {
            window.scrollTo(0, 0);
            _this._scrollToTopAfterNavigating = false;
        });
    };

    // Add property for checking if on mobile

    this.isMobile = !!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
    );
    GlobalClassUtility.toggleClass('is-mobile', this.isMobile);

    // Add properties for what breakpoint we're on

    [
        {
            key: 'Small',
            query: '(max-width : 720px)'
        },
        { key: 'Medium', query: '(min-width : 721px) and (max-width : 1030px)' }
    ].forEach(function(breakpoint) {
        var mq = window.matchMedia(breakpoint.query);
        $scope.$root['isBreakpoint' + breakpoint.key] = mq.matches;
        mq.addListener(function(mq) {
            $scope.$apply(function() {
                $scope.$root['isBreakpoint' + breakpoint.key] = mq.matches;
            });
        });
    });

    var onModalChange = function(newModal) {
        GlobalClassUtility.toggleClass('is-modal-open', newModal);
    };

    $scope.$watch(
        function() {
            return this.modal;
        }.bind(this),
        onModalChange
    );
};
WB.AppController.$inject = [
    '$scope',
    '$route',
    '$timeout',
    '$location',
    '$document',
    'GlobalClassUtility',
    '_User',
    'Metadata',
    '_Config',
    'PathHelper',
    'ResponsiveMenu',
    'Share',
    'RoutingHistory',
    'MetadataDataManager'
];

WB.App.controller('WB.AppController', WB.AppController);
